/**
 * Stable CSS class names for E2E — Post checkout insights page.
 */
export const PCI = {
    page: 'post-checkout-insights-page',
    frameCard: 'post-checkout-insights-page__frame-card',
    iframe: 'post-checkout-insights-page__iframe',
} as const;

export const pciCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

